import { createAction } from '@ngrx/store';
import { ListOfStatesResponse } from '../entities/Api/ListOfStatesResponse';

export const GetStates = createAction('[User-State] fetch states');

export const PutStates = createAction('[User-State] put states', (states: ListOfStatesResponse[]) => ({ states }));

export const SetUserState = createAction('[User-State] set state', (id: number) => ({ id }));
